import { render, staticRenderFns } from "./OrderDetailVoucher.vue?vue&type=template&id=2603b36b&scoped=true&"
import script from "./OrderDetailVoucher.vue?vue&type=script&lang=js&"
export * from "./OrderDetailVoucher.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailVoucher.vue?vue&type=style&index=0&id=2603b36b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603b36b",
  null
  
)

export default component.exports